// FILE: src/services/caseFactoryService.js
// Client wrappers for Question Factory case generation (migration 077 +
// the case-factory-generate edge function). The client orchestrates the
// steps sequentially; every step persists server-side, so a refresh simply
// resumes from step_status.

import { supabase } from './supabaseClient';

async function callRpc(fn, args) {
  const { data, error } = await supabase.rpc(fn, args);
  if (error) throw new Error(`[caseFactoryService] ${fn}: ${error.message}`);
  return data;
}

export function createCaseRun(examId, provider, inputs) {
  return callRpc('admin_create_case_run', {
    p_exam_id: examId, p_source: provider, p_inputs: inputs,
  });
}

export function getCaseDraft(draftId) {
  return callRpc('admin_get_case_draft', { p_draft_id: draftId });
}

export function listCaseRuns() {
  return callRpc('admin_list_case_runs');
}

/** Invoke one generation step. `extra` carries stage / scope / guidance. */
export async function runCaseStep(draftId, step, provider, extra = {}) {
  const { data, error } = await supabase.functions.invoke('case-factory-generate', {
    body: { draftId, step, provider, ...extra },
  });
  if (error) throw new Error(`[caseFactoryService] ${step}: ${error.message}`);
  if (data && data.error) throw new Error(`[caseFactoryService] ${step}: ${data.error}`);
  return data.draft;
}

/** Mark a draft imported/rejected (audited via the shared progress RPC). */
export function setCaseDraftStatus(draftId, status, importedCaseId = null) {
  return callRpc('upsert_case_draft_progress', {
    p_draft_id: draftId, p_status: status, p_imported_case_id: importedCaseId,
  });
}
